const API_SERVER =
  'https://api-dot-hosepoddev.uc.r.appspot.com' ||
   'http://localhost:5000' ||
   'http://192.168.1.20:5000'

export default API_SERVER
